export { default } from './FeedArticle';
